var _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "bevel"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-425.451,-421.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.978,538.889L26.978,637.889L98.978,637.889L98.978,565.889L71.978,538.889L26.978,538.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.978,637.889L26.978,538.889L98.978,538.889L98.978,637.889L26.978,637.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.978,565.474L99.978,638.889L25.978,638.889L25.978,537.889L72.393,537.889L99.978,565.474ZM27.978,539.889L27.978,636.889L97.978,636.889L97.978,566.303L71.564,539.889L27.978,539.889Z",
    style: {
      fill: "rgb(0,110,108)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.978,565.889L98.978,565.889L71.978,538.889L71.978,565.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.478,552.389L71.978,538.889L98.978,565.889L85.478,579.389L58.478,552.389Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.979,538.889L98.979,565.889L71.979,565.889L71.979,538.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(0,110,108)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.251,560.385C40.728,555.66 36.373,563.72 36.373,563.72L45.174,564.368C35.077,567.333 37.856,577.338 37.856,577.338L46.75,569.278C44.805,573.633 49.065,576.875 49.065,576.875L51.66,565.943C51.66,565.943 60.977,576.672 63.884,587.548C60.164,589.434 54.406,592.668 49.871,593.235C43.621,594.016 36.37,598.198 36.37,598.198L36.37,603.156L89.625,603.156L89.577,595.252C88.015,594.47 85.027,588.547 80.339,588.156C76.366,587.826 71.28,586.377 68.393,586.179C64.85,580.268 58.882,570.93 53.835,566.057L67.594,566.777C63.888,557.884 54.439,561.034 54.439,561.034L60.831,555.66C59.418,555.089 58.148,554.852 57.015,554.852C51.54,554.851 49.251,560.385 49.251,560.385Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.077,603.156L35.077,554.851L89.625,554.851L89.625,603.156L35.077,603.156Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,330.22,-1806.84)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "38.978px",
    y: "629.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "GIF"))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-99,99,-4.3e-06,62.9785,637.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,107,106)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(23,187,186)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.4999,-13.4999,13.4999,13.4999,71.9785,565.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(215,237,232)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    style: {
      stopColor: "rgb(157,201,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,107,106)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.1e-06,-48.3047,48.3047,-2.1e-06,62.9976,603.156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,129,129)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,56,54)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.e42da80dcd7b1f87ac8db285601d32e2.svg";
export { ForwardRef as ReactComponent };